<template>
  <el-form ref="formData" :loading="loading" :model="formData" :rules="formRules" :inline="true" small="small">
    <el-row>
      <el-col :span="6">
        <el-form-item label="治疗总费用" prop="operationAmount">
          <el-input v-if="localReadOnly" :value="parseFloat(formData.operationAmount || 0).toFixed(2)" disabled size="small" />
          <MoneyInput v-else v-model="formData.operationAmount" @input="calcOutlay" :disabled="localReadOnly"></MoneyInput>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="医保报销" prop="reimburAmount">
          <el-input v-if="localReadOnly" :value="parseFloat(formData.reimburAmount || 0).toFixed(2)" disabled size="small" />
          <MoneyInput v-else v-model="formData.reimburAmount" @input="calcOutlay" :disabled="localReadOnly"></MoneyInput>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="其他资助" prop="otherHelp">
          <el-input v-if="localReadOnly" :value="parseFloat(formData.otherHelp || 0).toFixed(2)" disabled size="small" />
          <MoneyInput v-else v-model="formData.otherHelp" @input="calcOutlay" :disabled="localReadOnly"></MoneyInput>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="医院减免" prop="hospitalReduction">
          <el-input v-if="localReadOnly" :value="parseFloat(formData.hospitalReduction || 0).toFixed(2)" disabled size="small" />
          <MoneyInput v-else v-model="formData.hospitalReduction" @input="calcOutlay" :disabled="localReadOnly"></MoneyInput>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-form-item label="救助费用" prop="helpAmount">
          <!-- <el-input type="text" v-model="formData.helpAmount" :disabled="true" size="small">
            <el-tooltip
              slot="suffix"
              :content="'救助费用' + (formData.helpAmount || 0) + ' = 手术费用' + (formData.operationAmount || 0) + ' - 医保报销' + (formData.reimburAmount || 0) + ' - 其他资助' + (formData.otherHelp || 0) + ' - 医院减免' + (formData.hospitalReduction || 0) + '； (不大于资助限额)'"
              effect="light"
              placement="top-start">
              <i class="el-input__icon el-icon-warning-outline" style="color: red;"></i>
            </el-tooltip>
          </el-input> -->
          <el-input v-if="localReadOnly" :value="parseFloat(formData.helpAmount || 0).toFixed(2)" disabled size="small" />
          <MoneyInput v-else v-model="formData.helpAmount" :disabled="localReadOnly"></MoneyInput>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="自付费用" prop="selfPayAmount">
          <!-- <el-input type="text" v-model="formData.selfPayAmount" :disabled="true" size="small">
            <el-tooltip
              slot="suffix"
              :content="'自付费用' + (formData.selfPayAmount || 0) + ' = 手术费用' + (formData.operationAmount || 0) + ' - 医保报销' + (formData.reimburAmount || 0) + ' - 其他资助' + (formData.otherHelp || 0) + ' - 医院减免' + (formData.hospitalReduction || 0) + ' - 救助费用' + (formData.helpAmount || 0)"
              effect="light"
              placement="top-start">
              <i class="el-input__icon el-icon-warning-outline" style="color: red;"></i>
            </el-tooltip>
          </el-input> -->
          <el-input v-if="localReadOnly" :value="parseFloat(formData.selfPayAmount || 0).toFixed(2)" disabled size="small" />
          <MoneyInput v-else v-model="formData.selfPayAmount" :disabled="localReadOnly"></MoneyInput>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="formData.hospitalIsAuto == 1" :span="6">
        <el-form-item label="手术名称" prop="operationName">
          <el-input :value="formData.operationName || '-'" disabled size="small" />
        </el-form-item>
      </el-col>
      <el-col v-else-if="formData.initialProject == 'AY1001'" :span="6">
        <el-form-item v-if="formData.initialProject == 'AY1001'" label="手术方式" prop="operationMode">
          <DictionarySelect v-model="formData.operationMode" :lazy="true" tableCode="OPERATION_MODE" :disabled="localReadOnly"></DictionarySelect>
        </el-form-item>
      </el-col>
      <el-col v-else :span="6">
        <el-form-item label="是否手术" prop="isOperation">
          <el-select v-model="formData.isOperation" :disabled="localReadOnly" size="small" clearable @change="isOperationChange">
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item v-if="formData.initialProject == 'AY1001' || (formData.initialProject == 'AY1003' && formData.isOperation == 1)" label="手术时间" prop="operationTime">
          <el-date-picker
            v-model="formData.operationTime"
            align="right"
            type="date"
            size="small"
            placeholder="选择时间"
            :disabled="localReadOnly || (formData.initialProject == 'AY1003' && formData.isOperation == 0)"
            :picker-options="pickerOptions"
            value-format="timestamp"
            @input="calcAge">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="手术时间" v-else>
          <el-input type="text" value="-" :disabled="true" size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="手术年龄" prop="operationAge">
          <el-input type="text" v-if="formData.operationAge" v-model="formData.operationAge" :disabled="true" size="small" />
          <el-input type="text" v-else value="-" :disabled="true" size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="住院号" prop="inHospitalNo">
          <el-input type="text" v-model="formData.inHospitalNo" :disabled="localReadOnly" placeholder="请输入" size="small" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-form-item label="入院时间" prop="inHospitalTime">
          <el-date-picker
            v-model="formData.inHospitalTime"
            align="right"
            type="date"
            size="small"
            placeholder="选择时间"
            value-format="timestamp"
            :picker-options="pickerOptions"
            :disabled="localReadOnly">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="出院时间" prop="outHospitalTime">
          <el-date-picker
          v-model="formData.outHospitalTime"
           align="right"
           type="date"
           size="small"
            placeholder="选择时间"
            value-format="timestamp"
            :picker-options="pickerOptions1"
             :disabled="localReadOnly"
             ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="治愈状态" prop="healState">
          <DictionarySelect v-model="formData.healState" :lazy="true" tableCode="HEAL_STATE" :excludeKeys="this.hospitalName == '武汉大学中南医院' ?[]:['7']" :disabled="localReadOnly"></DictionarySelect>
        </el-form-item>
      </el-col>
      <el-col v-if="formData.hospitalIsAuto == 1" :span="6">
        <el-form-item label="电子发票" prop="einvoice">
          <span v-if="formData.einvoice" class="link" @click="openInvoice(formData.einvoice)">点击查看</span>
          <span v-else>-</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="术前病种" prop="beforeDiseasesList">
          <el-input :value="formData.beforeDiseasesName || '-'" disabled size="small" />
          <!-- <DiseaseCascader
            v-model="formData.beforeDiseasesIdList"
            :hospitalId="formData.hospitalId"
            :multiple="true"
            :disabled="true">
          </DiseaseCascader> -->
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="术后病种" prop="afterDiseasesIdList">
          <el-input v-if="formData.hospitalIsAuto == 1" :value="formData.afterDiseasesText || '-'" disabled size="small" />
          <el-input v-else-if="localReadOnly" :value="formData.afterDiseasesName || '-'" disabled size="small" />
          <DiseaseCascader
            v-else
            v-model="formData.afterDiseasesIdList"
            :hospitalId="formData.hospitalId"
            :multiple="true"
            :disabled="localReadOnly">
          </DiseaseCascader>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="formData.remark" :rows="3" size="small" :disabled="localReadOnly" style="width: 100%;"/>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="注册时间" prop="helpTime">
          <el-date-picker :value="formData.registTime" align="right" type="date" size="small" placeholder="选择时间" value-format="timestamp" :disabled="true"></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <el-row>
      <el-col :span="12">
        <el-form-item label="发票附件" prop="attachList">
          <FileUpload v-model="formData.attachList" :disabled="localReadOnly"></FileUpload>
        </el-form-item>
      </el-col>
    </el-row> -->
  </el-form>
</template>

<script>
import { getOutlayDataById, saveCureOutlay, submitCureOutlay } from "@/util/api.js";
import DictionarySelect from "@/components/business/DictionarySelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import FileUpload from "@/components/business/FileUpload";
import MoneyInput from "@/components/business/MoneyInput";
import {getAccountSystemInfo} from "../../../util/api";

export default {
  components: {
    DictionarySelect,
    DiseaseCascader,
    FileUpload,
    MoneyInput
  },
  props: {
    outlayId: String,
    readOnly: false,
  },
  data () {
    let _this = this
    return {
      loading: false,
      localReadOnly: true,
      pickerOptions: {
        disabledDate (time) {
          let birthday = new Date(_this.formData.birthday);
          let startDate = birthday.setDate(birthday.getDate() - 1);
          return time.getTime() > Date.now() || time.getTime() < startDate;
        }
      },
      pickerOptions1: {
        disabledDate (time) {
          // 今天的日期（不包含时间部分）
          const today = new Date(new Date().setHours(0, 0, 0, 0));
          // 如果日期大于今天，则禁用它
          return time.getTime() > today.getTime();
        }
      },
      formData: {},
      formRules: {
        operationAmount: [{ required: true, message: '请输入治疗总费用', trigger: 'blur' }],
        reimburAmount: [{ required: true, message: '请输入医保报销', trigger: 'blur' }],
        otherHelp: [{ required: true, message: '请输入其他资助', trigger: 'blur' }],
        hospitalReduction: [{ required: true, message: '请输入医院减免', trigger: 'blur' }],
        isOperation: [{ required: true, message: '请选择是否手术', trigger: 'change' }],
        operationMode: [{ required: true, message: '请选择手术方式', trigger: 'change' }],
        operationTime: [{ required: true, message: '请选择手术时间', trigger: 'blur' }],
        inHospitalNo: [{ required: true, message: '请输入住院号', trigger: 'blur' }],
        inHospitalTime: [{ required: true, message: '请选择入院时间', trigger: 'blur' }],
        afterDiseasesIdList: [{ required: true, message: '请选择术后病种', trigger: 'blur' }],
        healState: [{ required: true, message: '请选择治愈状态', trigger: 'change' }],
        helpAmount: [{ required: true, message: '请输入救助费用', trigger: 'blur' }],
        selfPayAmount: [{ required: true, message: '请输入自付费用', trigger: 'blur' }],
      },
      hospitalName:''
    }
  },
  watch: {
    outlayId: {
      immediate: true,
      handler () {
        this.loadData()
      }
    }
  },
  created() {
    this.getHospitalInfo();
  },
  methods: {
    loadData () {
      if (this.outlayId) {
        this.loading = true;
        getOutlayDataById(this.outlayId).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.formData = res.responseData;
            if (this.formData.beforeDiseasesList && this.formData.beforeDiseasesList.length > 0) {
              this.formData.beforeDiseasesIdList = this.formData.beforeDiseasesList.map(dis => {
                return dis.diseasesId;
              });
            }
            if (this.formData.afterDiseasesList && this.formData.afterDiseasesList.length > 0) {
              this.formData.afterDiseasesIdList = this.formData.afterDiseasesList.map(dis => {
                return dis.diseasesId;
              });
            } else {
              this.formData.afterDiseasesIdList = this.formData.beforeDiseasesIdList;
            }
            this.formData.otherHelp = this.formData.otherHelp || 0;
            this.formData.hospitalReduction = this.formData.hospitalReduction || 0;
            // this.formData.helpAmount = this.formData.helpAmount || 0;
            // this.formData.selfPayAmount = this.formData.selfPayAmount || 0;
            if (this.formData.hospitalIsAuto == 1) {
              this.localReadOnly = true;
            } else {
              this.localReadOnly = this.readOnly || (this.formData.isSend == 1 ? true : [0, 1, 2].indexOf(this.formData.outlayStatus) < 0);
            }
            this.calcAge();
            this.$emit('onload', this.formData);
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.localReadOnly = true;
      }
    },
    calcOutlay () {
      // this.formData.helpAmount = parseFloat(this.formData.operationAmount || 0) - parseFloat(this.formData.reimburAmount || 0) - parseFloat(this.formData.otherHelp || 0) - parseFloat(this.formData.hospitalReduction || 0);
      // let quota = parseFloat(this.formData.helpQuota || 0) + parseFloat(this.formData.specialQuota || 0);
      // if (parseFloat(this.formData.helpAmount || 0) > quota) {
      //   this.formData.selfPayAmount = (parseFloat(this.formData.helpAmount || 0) - quota).toFixed(2);
      //   this.formData.helpAmount = quota;
      // } else {
      //   this.formData.selfPayAmount = 0;
      // }
      // this.formData.helpAmount = parseFloat(this.formData.helpAmount || 0).toFixed(2);
      // this.formData.selfPayAmount = parseFloat(this.formData.selfPayAmount || 0).toFixed(2);
    },
    calcAge () {
      if (this.formData.isOperation == 1 && this.formData.operationTime && this.formData.birthday) {
        this.formData.operationTime = new Date(this.formData.operationTime);

        let endDate = this.formData.operationTime;
        let startDate = new Date(this.formData.birthday);
        let year = endDate.getFullYear() - startDate.getFullYear();
        let month = endDate.getMonth() - startDate.getMonth();
        let day = endDate.getDate() - startDate.getDate();

        if (month <= 0) {
          year--;
          month = endDate.getMonth() + 1 + (12 - (startDate.getMonth() + 1));
        }
        if (day < 0) {
          month--;
          let monthDayList = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2];
          let monthDays = 0;
          let index = monthDayList.findIndex(d => {
            return d === startDate.getMonth() + 1
          });
          if (index <= 6) {
            monthDays = 31;
          } else if (index > 6 && index <= 10) {
            monthDays = 30;
          } else {
            monthDays = year % 4 == 0 ? 29 : 28;
          }
          day = endDate.getDate() + (monthDays - startDate.getDate());
        } else if (day >= 0 && month == 12) {
          year += 1;
          month = 0;
        }

        this.formData.operationAge = (year + '岁') + (month + '月') + (day + '天')
      } else {
        this.formData.operationAge = null;
      }
    },
    saveData () {
      let valid = this.validateParams();
      if (valid) {
        this.loading = true;
        this.$emit('beforeSave');
        let params = this.makeParams();
        saveCureOutlay(params).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.$message.success('暂存成功！');
            this.$emit('success', this.formData);
          } else {
            this.$message.error(res.msg)
          }
          this.$emit('complete');
        })
      } else {
        this.$emit('complete');
      }
    },
    submitData () {
      this.$refs.formData.validate((valid) => {
        let validParams = this.validateParams();
        if (valid && validParams) {
          this.loading = true;
          this.$emit('beforeSave');
          console.log(222)
          let params = this.makeParams();
          submitCureOutlay(params).then(res => {
            this.loading = false;
            if (res.msgCode == 200) {
              this.$message.success('提交成功！');
              this.$emit('success', this.formData);
            } else {
              this.$message.error(res.msg)
            }
            this.$emit('complete');
          })
        } else {
          this.$emit('complete');
        }
      });
    },
    validateParams () {
      let quota = parseFloat(this.formData.helpQuota || 0) + parseFloat(this.formData.specialQuota || 0);
      if (parseFloat(this.formData.helpAmount || 0) > quota) {
        this.$message.error('救助费用不能大于资助限额！');
          return false;
      }
      if (this.formData.operationTime && this.formData.registTime && this.formData.initialProject == 'AY1001') {
        let registTime = new Date(this.formData.registTime);
        if (new Date(this.formData.operationTime) < new Date(registTime.getFullYear(), registTime.getMonth(), registTime.getDate())) {
          this.$message.error('手术时间必须在注册时间之后！');
          return false;
        }
      }
      if (this.formData.operationTime && this.formData.inHospitalTime) {
        if (new Date(this.formData.operationTime) < new Date(this.formData.inHospitalTime)) {
          this.$message.error('手术时间不能小于入院时间！');
          return false;
        }
        if (this.formData.outHospitalTime) {
          if (new Date(this.formData.operationTime) >= new Date(this.formData.outHospitalTime)) {
            this.$message.error('手术时间不能大于等于出院时间！');
            return false;
          }
        }
      }
      if (this.formData.inHospitalTime && this.formData.outHospitalTime) {
        if (new Date(this.formData.inHospitalTime) >= new Date(this.formData.outHospitalTime)) {
          this.$message.error('入院时间不能小于等于出院时间！');
          return false;
        }
      }
      return true;
    },
    makeParams () {
      if (this.formData.afterDiseasesIdList && this.formData.afterDiseasesIdList.length > 0) {
        this.formData.afterDiseases = this.formData.afterDiseasesIdList.join(',');
      } else {
        this.formData.afterDiseases = null;
      }
      let params = {
        ...this.formData
      }
      delete params.helpQuota;
      delete params.specialQuota;
      delete params.donors;
      return params;
    },
    isOperationChange (val) {
      this.formData.isOperation = val;
      if (val == 0) {
        this.formData.operationTime = null;
        this.formData.operationAge = null;
      }
    },
    openInvoice (invoice) {
      window.open(invoice)
    },
    getHospitalInfo(){
      getAccountSystemInfo().then((res) => {
        if(res.msgCode==200){
          this.hospitalName=res.responseData.name;
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import './../../../common/form.scss';
.link {
  color: #E8556F;
  text-decoration: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/outlay/cure/CureOutlayTxCxForm.vue